export const record_limits = [25,50,75,100] //used to set the limits from one signle place
export const default_limit = 25;